import * as React from 'react';
import { Button } from '@material-ui/core';
import moment from 'moment';
import { isNullOrUndefined } from 'util';
import { OrderStatusHistory } from '../../interfaces/Order';

export interface OrderHistoryTimelineProps {
  items: OrderStatusHistory[];
  longDateFormat: string;
  emptyLabel: string;
  onDownload: (fileName: string, originalFileName: string) => void;
}

const OrderHistoryTimeline: React.FC<OrderHistoryTimelineProps> = ({
  items,
  longDateFormat,
  emptyLabel,
  onDownload
}) => {
  if (items.length === 0) {
    return <b>{emptyLabel}</b>;
  }

  return (
    <div className="timeline-list  timeline-list--primary">
      {items.map((orderStatus, index) => (
        <div key={index} className="timeline-item">
          <div className="timeline-item--content">
            <div className="timeline-item--icon " />
            <h4 className="timeline-item--label font-weight-bold">
              {' '}
              {orderStatus.orderStatus!.displayName}
            </h4>
            <p className="mt-2 text-black-50 font-weight-bold">
              {moment.utc(orderStatus.date).local().format(longDateFormat)}
              {!isNullOrUndefined(orderStatus.createdByUser)
                ? '(' + orderStatus.createdByUser.userName + ')'
                : ''}
            </p>
            <p className="mt-2 text-black">{orderStatus.comment}</p>

            {orderStatus.attachments === null
              ? null
              : orderStatus.attachments.map((attach, attachIndex) => (
                  <div key={attachIndex} className="d-flex flex-row w-100">
                    <div className="w-75 text-left">
                      <Button
                        color="primary"
                        className="text-primary text-left"
                        onClick={() => onDownload(attach.fileName, attach.originalFileName)}
                      >
                        <span className="crop">{attach.originalFileName}</span>
                      </Button>
                    </div>
                  </div>
                ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrderHistoryTimeline;
